module.exports = __webpack_public_path__ + "static/media/close-icon.7c59126b.svg";